var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79998 1.6001C6.2418 1.6001 6.59998 1.95827 6.59998 2.4001V3.2001H9.79998V2.4001C9.79998 1.95827 10.1581 1.6001 10.6 1.6001C11.0418 1.6001 11.4 1.95827 11.4 2.4001V3.2001H12.2C13.0836 3.2001 13.8 3.91644 13.8 4.8001V12.0001C13.8 12.8838 13.0836 13.6001 12.2 13.6001H4.19998C3.31632 13.6001 2.59998 12.8838 2.59998 12.0001V4.8001C2.59998 3.91644 3.31632 3.2001 4.19998 3.2001H4.99998V2.4001C4.99998 1.95827 5.35815 1.6001 5.79998 1.6001ZM4.99998 6.4001C4.55815 6.4001 4.19998 6.75827 4.19998 7.2001V11.2001C4.19998 11.6419 4.55815 12.0001 4.99998 12.0001H11.4C11.8418 12.0001 12.2 11.6419 12.2 11.2001V7.2001C12.2 6.75827 11.8418 6.4001 11.4 6.4001H4.99998Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ddef60488c7cff045fcad154bac6ef1f.svg";
export { ForwardRef as ReactComponent };